import React, { memo } from 'react';
import { Modal, Media } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import DealerLocatorInput from '../DealerLocatorInput';
import DealerLocatorInputOptions from '../DealerLocatorInputOptions';
import EditAddressBar from './EditAddressBar';

const AddressBar = ({
  locationLabel,
  buttonLabel,
  dealerCardsListRef,
  isOpen,
  setIsOpen,
  setSelectedDealer,
  setSelectedPlace,
  inputValue,
  setInputValue,
}) => {
  const scrollToTop = () => {
    if (!dealerCardsListRef?.current) return;
    dealerCardsListRef.current.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleShowModal = () => {
    setIsOpen(prevState => !prevState);
    scrollToTop();
    setSelectedDealer(null);
  };

  return (
    <>
      <EditAddressBar locationLabel={locationLabel} handleShowModal={handleShowModal} buttonLabel={buttonLabel} />
      <Media lessThan="desktop">
        <Modal
          isOpen={isOpen}
          styling="fullWidth"
          closeModal={() => setIsOpen(false)}
          ariaLabel="enter location modal"
          allowClose
          iconSize="default"
          data-testid="location-search-modal"
        >
          {() => (
            <>
              <DealerLocatorInputOptions />
              <DealerLocatorInput
                setIsOpen={setIsOpen}
                setSelectedPlace={setSelectedPlace}
                inputValue={inputValue}
                setInputValue={setInputValue}
                setSelectedDealer={setSelectedDealer}
              />
            </>
          )}
        </Modal>
      </Media>
      <Media greaterThanOrEqual="desktop">
        {isOpen && (
          <DealerLocatorInput
            setIsOpen={setIsOpen}
            setSelectedPlace={setSelectedPlace}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setSelectedDealer={setSelectedDealer}
          />
        )}
      </Media>
    </>
  );
};

AddressBar.propTypes = {
  dealerCardsListRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  locationLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  setSelectedDealer: PropTypes.func.isRequired,
  setSelectedPlace: PropTypes.func.isRequired,
  inputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
};

export default memo(AddressBar);
